var TableVisiblityOptionsModal = (function (base) {
  __extends(TableVisiblityOptionsModal, base);

  function TableVisiblityOptionsModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

  TableVisiblityOptionsModal.prototype.activate = function (htmlContent, title, table, columns) {
    const self = this;
    const $modal = ModalHelper.create().show().busy();
    self.$modal = $modal;

    htmlContent = htmlContent.replace('\${title}', title);

    $modal.content(htmlContent).busy(false);

    columns.forEach(function (column) {
      $modal
        .find('#{Name}-checkbox'.format(column))
        .prop('checked', table.column('{Name}:name'.format(column)).visible());
    });

    $modal
      .on('click', '[js=close],.close', () => {
        self.close({ cancel: true });
      })
      .on('keydown',
        e => {
          if (e.keyCode === 27) {
            self.close({ cancel: true });
            e.stopPropagation();
          }
        });
  };

  return TableVisiblityOptionsModal;
}(BaseModal));
